import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BadgeVisibility from './BadgeVisibility';
import ClientProvider from './client';
export default createDemo(import.meta.url, BadgeVisibility, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/badges/demos/visibility/BadgeVisibility.tsx",
    "fileName": "BadgeVisibility.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Stack from '@mui/material/Stack';\nimport Badge from '@mui/material/Badge';\nimport IconButton from '@mui/material/IconButton';\nimport Switch from '@mui/material/Switch';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport MailIcon from '@mui/icons-material/Mail';\n\nconst unreadMessagesCount = 4;\n\nexport default function BadgeVisibility() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [invisible, setInvisible] = React.useState(false);\n\n  const handleBadgeVisibility = () => {\n    setInvisible((previousInvisible) => !previousInvisible);\n  };\n\n  return (\n    <Stack direction=\"row\" spacing={3} sx={{ alignItems: 'center' }}>\n      <IconButton\n        aria-label={\n          invisible\n            ? 'open inbox'\n            : `open inbox, ${unreadMessagesCount} unread messages`\n        }\n      >\n        <Badge\n          color=\"secondary\"\n          badgeContent={unreadMessagesCount}\n          invisible={invisible}\n        >\n          <MailIcon />\n        </Badge>\n      </IconButton>\n      <FormControlLabel\n        control={<Switch checked={!invisible} onChange={handleBadgeVisibility} />}\n        label=\"Show unread count\"\n      />\n    </Stack>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 41,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Stack from '@mui/material/Stack';\nimport Badge from '@mui/material/Badge';\nimport IconButton from '@mui/material/IconButton';\nimport Switch from '@mui/material/Switch';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport MailIcon from '@mui/icons-material/Mail';\n\nconst unreadMessagesCount = 4;\n\nexport default function BadgeVisibility() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [invisible, setInvisible] = React.useState(false);\n\n  const handleBadgeVisibility = () => {\n    setInvisible((previousInvisible) => !previousInvisible);\n  };\n\n  return (\n    <Stack direction=\"row\" spacing={3} sx={{ alignItems: 'center' }}>\n      <IconButton\n        aria-label={\n          invisible\n            ? 'open inbox'\n            : `open inbox, ${unreadMessagesCount} unread messages`\n        }\n      >\n        <Badge\n          color=\"secondary\"\n          badgeContent={unreadMessagesCount}\n          invisible={invisible}\n        >\n          <MailIcon />\n        </Badge>\n      </IconButton>\n      <FormControlLabel\n        control={<Switch checked={!invisible} onChange={handleBadgeVisibility} />}\n        label=\"Show unread count\"\n      />\n    </Stack>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 41,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Stack",
      "@mui/material/Badge",
      "@mui/material/IconButton",
      "@mui/material/Switch",
      "@mui/material/FormControlLabel",
      "@mui/icons-material/Mail"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
